import { Star } from "lucide-react";
import { CONTACT } from "../data/content";

const GoogleG = ({ className }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden>
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
  </svg>
);

const Stars = ({ size }) => (
  <span className="flex gap-0.5" aria-hidden>
    {[0, 1, 2, 3, 4].map((i) => <Star key={i} className={size} fill="#FFC20E" stroke="#FFC20E" />)}
  </span>
);

export const ReviewBadge = ({ size = "md", testId = "review-badge", className = "" }) => {
  if (size === "hero") {
    return (
      <a href={CONTACT.triviaNation} target="_blank" rel="noreferrer" data-testid={testId} title="Trivia Nation reviews on Google"
        className={`group mx-auto flex max-w-full flex-col items-center text-center ${className}`}>
        <span className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
          <GoogleG className="h-10 w-10 sm:h-12 sm:w-12" />
          <span className="font-display text-5xl leading-none text-black sm:text-6xl">5.0</span>
          <Stars size="h-7 w-7 sm:h-8 sm:w-8" />
        </span>
        <span className="mt-4 text-base font-medium text-black sm:text-lg">Rated 5.0 on Google from 2,500+ reviews</span>
        <span className="mt-1 text-sm text-black/55 group-hover:text-en-teal transition-colors">Powered by Trivia Nation, a sister company</span>
      </a>
    );
  }
  return (
    <a href={CONTACT.triviaNation} target="_blank" rel="noreferrer" data-testid={testId} title="Trivia Nation reviews on Google"
      className={`group mx-auto flex max-w-full flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-center ${className}`}>
      <GoogleG className="h-6 w-6 shrink-0 sm:h-7 sm:w-7" />
      <Stars size="h-4 w-4" />
      <span className="text-sm font-semibold text-black">2,500+ reviews</span>
      <span className="basis-full text-xs text-black/55 group-hover:text-en-teal transition-colors sm:basis-auto sm:whitespace-nowrap">Trivia Nation, a sister company · Google</span>
    </a>
  );
};
